<template>
  <div class="flex flex-col space-y-6">
    <div>
      <div class="flex justify-between content-center items-center">
        <span class="text-md lg:text-2xl text-gray font-medium">  {{campaign.pledge_drive.formattedPledgeTotalActivities}} {{campaign.pledge_drive_activity_type}}</span>
        <span class="text-3xl lg:text-5xl font-bold">${{campaign.pledge_drive.pledge_total_donation_amount}} <span class="text-xl lg:text-3xl font-medium">Raised</span></span>
      </div>
      <div id="progress-bar" class="w-full h-8 my-2 relative overflow-hidden">
        <div id="progress-indicator" :style="{width: this.progressCounter+'%'}" class="h-8 transition duration-500 ease-in-out">
          <div class="h-16 w-10 bg-green rotate-45 transform origin-top-right ml-100percent">&nbsp;</div>
        </div>
      </div>
      <div class="flex justify-between content-center items-center">
        <span class="text-md lg:text-2xl text-gray font-medium">{{this.campaign.pledge_drive.achieved}}% Achieved</span>
        <span @click="showStat = !showStat" class="text-xs lg:text-sm text-gray-400 hover:text-pink cursor-pointer font-medium">(View Stats)</span>
        <span class="text-md lg:text-2xl text-gray font-medium">Goal: {{campaign.pledge_drive.formattedGoal}} {{campaign.pledge_drive_activity_type}}</span>
      </div>
    </div>

    <div v-if="showStat && !campaign.parent_id" class="border border-gray-200 flex flex-wrap">
      <div class="bg-gray-150 p-4 border-b lg:border-b-0 lg:border-r border-gray-200 w-full lg:w-1/4 flex-grow-1">
        <span class="text-xs text-gray-500" >Time Left</span>
        <span v-if="!campaign.pledge_drive.hasEnded" class="uppercase text-lg font-medium block">{{campaign.pledge_drive.daysLeft}} days, {{campaign.pledge_drive.hoursLeft}} hours</span>
        <span  v-else class="uppercase text-lg font-medium block">ENDED</span>
      </div>
      <div class="p-4 border-r border-gray-200 w-1/3 lg:w-1/4">
        <span class="text-xs text-gray-500">Pledges</span>
        <span class="uppercase text-lg font-medium block">{{campaign.pledge_drive.pledge_count}}</span>
      </div>
      <div class="p-4 border-r border-gray-200 w-1/3 lg:w-1/4">
        <span class="text-xs text-gray-500">Avg. Pledge</span>
        <span class="uppercase text-lg font-medium block">${{campaign.pledge_drive.averagePledgeAmount}}</span>
      </div>
      <div class="p-4 w-1/3 lg:w-1/4">
        <span class="text-xs text-gray-500">Est. Raised</span>
        <span class="uppercase text-lg font-medium block">${{campaign.pledge_drive.formattedTotalAmountDue}}</span>
      </div>
    </div>

    <div v-if="showStat && campaign.parent_id" class="border border-gray-200 flex flex-wrap">
      <div class="bg-gray-150 p-4 border-b lg:border-r border-gray-200 w-full flex-grow-1">
        <span v-if="!campaign.pledge_drive.hasEnded" class="uppercase text-lg font-medium block">{{campaign.pledge_drive.daysLeft}} days, {{campaign.pledge_drive.hoursLeft}} hours</span>
        <span  v-else class="uppercase text-lg font-medium block">ENDED</span>
      </div>
      <div class="p-4 border-r border-b lg:border-b-0 border-gray-200 w-1/2 lg:w-1/4">
        <span class="text-xs text-gray-500">Drives</span>
        <span class="uppercase text-lg font-medium block">{{campaign.pledgeDriveCount}}</span>
      </div>
      <div class="p-4 border-r border-b lg:border-b-0 border-gray-200 w-1/2 lg:w-1/4">
        <span class="text-xs text-gray-500">Pledges</span>
        <span class="uppercase text-lg font-medium block">{{campaign.pledge_drive.pledge_count}}</span>
      </div>
      <div class="p-4 border-r border-gray-200 w-1/2 lg:w-1/4">
        <span class="text-xs text-gray-500">Avg. Pledge</span>
        <span class="uppercase text-lg font-medium block">${{campaign.pledge_drive.averagePledgeAmount}}</span>
      </div>
      <div class="p-4 w-1/2 lg:w-1/4">
        <span class="text-xs text-gray-500">Est. Raised</span>
        <span class="uppercase text-lg font-medium block">${{campaign.pledge_drive.formattedTotalAmountDue}}</span>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'PledgeDriveCampaignGoal',
    props: {
      campaignId: {
        type: String,
        required: true,
      },
      campaign: {
        required: true,
      },
    },

    data() {
      return {
        progressCounter: 0,
        showStat: false,
      }
    },

    async mounted() {
      this.timer = setInterval(() => {
        this.progressCounter = this.campaign.pledge_drive.achieved
      }, 1000)
    },

  }
</script>
